import React from 'react';
import PropTypes from 'prop-types';
import InputSelect from '../inputSelect/InputSelect';
import Singleclose from '../../assets/image/SingeCloseRed.svg';
import './advanceFilter.scss';
import { MdClose } from 'react-icons/md';

const AdvanceFilterSelectInput = ({
	label,
	options,
	removeInput,
	placeholder,
	onFocusCb,
	disabled,
	onChange,
	value,
	error,
	onSelect,
	className = '',
	autoFocus = false,
}) => {
	const isHeaderFilter = className === 'selectInput';
	const isModalFilter = className === 'modalInput';

	return (
		<div
			className={`
		advance-filter-select-input
		${isHeaderFilter ? 'header-filter' : ''}
		${isModalFilter ? 'modal-filter' : ''}
	`}
		>

			<div className='advance-filter-select-input__content_body'>
				<div>
					{label && !isHeaderFilter && (
						<label className="advance-filter-select-input__label">
							{label}
						</label>
					)}
				</div>
				<div className="d-flex align-items-center gap-4">
					<div className="advance-filter-select-input__field">
						<InputSelect
							className={className}
							options={options}
							returnInputValue={true}
							onFocusCb={onFocusCb}
							onChange={onChange}
							placeholder={placeholder}
							onSelect={onSelect}
							autoFocus={autoFocus}
							value={value}
							disabled={disabled}
							error={error}
						/>
					</div>

					<button
						type="button"
						className="advance-filter-select-input__remove-btn"
						onClick={removeInput}
						aria-label="Remove Filter"
					>
						<MdClose size={28} />
					</button>
				</div>
			</div>
		</div>
	);
};

AdvanceFilterSelectInput.propTypes = {
	label: PropTypes.string,
	options: PropTypes.array,
	removeInput: PropTypes.func,
	placeholder: PropTypes.string,
	onFocusCb: PropTypes.func,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	value: PropTypes.any,
	error: PropTypes.string,
	onSelect: PropTypes.func,
	className: PropTypes.string,
	autoFocus: PropTypes.bool,
};

export default AdvanceFilterSelectInput;